export default __webpack_public_path__ + "static/media/dg2.336762ac.jpg";